import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

interface IErrorContext {
  httpError: FetchBaseQueryError | SerializedError | undefined;
  setHttpError: React.Dispatch<
    React.SetStateAction<FetchBaseQueryError | SerializedError | undefined>
  >;
}

export const ErrorContext = createContext<IErrorContext | undefined>(undefined);

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [httpError, setHttpError] = useState<
    FetchBaseQueryError | SerializedError
  >();
  const navigate = useNavigate();

  useEffect(() => {
    if (httpError) {
      // @ts-expect-error
      const errorCode = httpError.status;

      if (errorCode === 400) {
        toast.error("Ha ocurrido un problema");
      } else if (errorCode === 401 || errorCode === 403) {
        navigate("/login");
      } else if (errorCode >= 500) {
        navigate("/error");
      }
    }
  }, [httpError, navigate]);

  return (
    <ErrorContext.Provider value={{ httpError, setHttpError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export function useError(): IErrorContext {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useError must be used within a ErrorProvider");
  }
  return context;
}
